import React from "react";
import { ExternalLink } from "lucide-react";

function navigateToProduct(url) {
  if (!url) return;
  // Inside the embedded widget iframe, navigate the host page (top window)
  // so the user stays inside their original site context.
  try {
    if (window.top && window.top !== window.self) {
      // Ask the host page (widget-embed.js) to navigate, in case top.location is blocked
      window.top.postMessage({ type: "hellosir:navigate", url }, "*");
      // Best-effort direct navigation as well — works on most ecom sites
      try { window.top.location.href = url; return; } catch { /* cross-origin blocked */ }
    }
    window.location.href = url;
  } catch {
    window.location.href = url;
  }
}

/**
 * Renders an inline gallery of product cards inside chat bubbles.
 */
export default function ProductCards({ products = [], compact = false }) {
  if (!products || products.length === 0) return null;
  return (
    <div
      className={`grid ${compact ? "grid-cols-2" : "grid-cols-2"} gap-2 mt-2`}
      data-testid="chat-product-cards"
    >
      {products.slice(0, 6).map((p, i) => (
        <button
          type="button"
          key={i}
          onClick={() => navigateToProduct(p.url)}
          className="bg-white border border-[#E2E8F0] hover:border-[#0044FF] rounded-sm overflow-hidden flex flex-col group transition-colors text-left"
          data-testid={`chat-product-card-${i}`}
        >
          {p.image ? (
            <div className="aspect-square bg-[#F3F4F6] overflow-hidden">
              <img
                src={p.image}
                alt={p.name || "product"}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                loading="lazy"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            </div>
          ) : (
            <div className="aspect-square bg-[#F3F4F6] flex items-center justify-center text-[10px] font-mono text-[#4B5563]">
              no image
            </div>
          )}
          <div className="p-2 flex-1 flex flex-col">
            <div
              className={`font-medium ${compact ? "text-[11px]" : "text-xs"} text-[#030712] line-clamp-2`}
              title={p.name}
            >
              {p.name || "Untitled"}
            </div>
            <div className="mt-auto pt-1.5 flex items-baseline justify-between gap-1">
              {p.price ? (
                <div className={`font-display font-extrabold ${compact ? "text-xs" : "text-sm"} text-[#0044FF]`}>
                  {p.currency ? `${p.currency} ` : ""}
                  {p.regular_price && p.sale_price ? (
                    <>
                      <span className="text-[#4B5563] line-through font-normal text-[10px] mr-1">{p.regular_price}</span>
                      {p.sale_price}
                    </>
                  ) : (
                    p.price
                  )}
                </div>
              ) : (
                <div className="text-[10px] font-mono text-[#4B5563]">—</div>
              )}
              {p.url && <ExternalLink className="w-3 h-3 text-[#0044FF] opacity-0 group-hover:opacity-100 transition-opacity" />}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
